import React, { FC } from 'react';
import { ITabsProps } from '../types';

import { StyledTabs, StyledTab } from './styled';
import { Tooltip } from '../tooltip';

export const ToggleSwitchTabButton: FC<ITabsProps> = ({ value, onChange, options, orientation }, ...rest) => {
  return (
    <StyledTabs value={value} onChange={onChange} orientation={orientation} {...rest}>
      {options !== undefined &&
        options.map((item, index) => (
          <Tooltip title={item.label ?? ''} key={index}>
            <StyledTab key={index} icon={item.icon} centerRipple />
          </Tooltip>
        ))}
    </StyledTabs>
  );
};
